import { useState } from 'react';
import Loader from '../../../components/Common/Loader';
import { TeacherOnboardingStatusEnum, UserModel, UserRoleEnum } from '../../../interfaces/user.interface';

interface StepKickStartProps {
  startStepOne: (loader?: any) => void;
  user?: UserModel | null;
}

const StepKickStart = ({ startStepOne, user }: StepKickStartProps) => {
  const [loader, setLoader] = useState<boolean>(false);
  const isTeacherOnboarding =
    user?.role === UserRoleEnum.teacher &&
    user?.teacherOnboardingStatus === TeacherOnboardingStatusEnum.BookOnboarding;

  const handleSubmit = () => {
    setLoader(true);
    startStepOne(setLoader);
  };
  return (
    <div>
      {!isTeacherOnboarding && (
        <h2 className="text-left text-2xl md:text-4xl mb-4 font-bold text-storyblue">
          Let&apos;s Build Your Story
        </h2>
      )}
      {isTeacherOnboarding ? (
        <>
          <p className="mb-4 font-semibold text-base md:text-lg">
            BuildMyStory is your superpower for engaging and motivating students.
          </p>
          <p className="text-sm md:text-base">
            We&apos;ve created a book tour to help you get started. You&apos;ll see the exact steps your students
            follow to turn their writing into an illustrated book. It only takes a couple of minutes.
          </p>
        </>
      ) : (
        <>
          <p className="mb-4">
            Kickstart your personalized storytelling adventure by providing us with your child's name, desired
            story topic, book goal, and preferred art style, and we'll craft a unique, enchanting book just
            for them!
          </p>
          <p>
            The process is very easy and within just a few minutes you'll have a fully customized children's
            book. You will be able to upload an image of the main character of your book, pick your art style
            and we will generate a new version of that character that will be used throughout the book.
          </p>
        </>
      )}
      <button
        onClick={handleSubmit}
        disabled={loader}
        className={`flex justify-center items-center gap-2 bg-storyblue text-white font-bold rounded-full px-4 py-2 text-sm md:text-base mt-8 mb-4 ${
          loader ? 'opacity-50' : ''
        }`}
      >
        <span>Let&apos;s Get Started!</span>
        <Loader loader={loader} />
      </button>
    </div>
  );
};

export default StepKickStart;